import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `ControlSemen/addControlSemen`, method: 'POST', body: values, token: token})
}
